import { UI_URL } from "@data/GlobalData.js";
import { GetState, globalVariables } from "@genericComponents/StoreToolkit.js";
import {
  CFW_CURRENT_TRANSLATION,
  CFW_CURRENT_URL,
  Response_TranslationData,
} from "@genericComponents/CFW.js";
import { GetConfig } from "@genericComponents/SFW.js";
import { User } from "@genericComponents/User.js";
const LanguagesData = await import("@data/LanguagesData.js").then(
  (mod) => mod.LanguagesData,
);
const ExtractPath = await import("@asyncImports/ExtractPath.js").then(
  (mod) => mod.ExtractPath,
);
const CleanUrl = await import("@asyncImports/CleanUrl.js").then(
  (mod) => mod.CleanUrl,
);
export const GenerateNameFromUrl = (paramUrl) => {
  return paramUrl.substring(paramUrl.lastIndexOf("/") + 1).split(".")[0];
};
export const GetDefaultAdsenseId = (adsIdx) => {
  const adsensIds = GetConfig("CompanyAdSlot").split(",");
  return adsensIds[adsIdx];
};
export const GeneratePath = (
  languageCode,
  productCode,
  val,
  isShare = false,
) => {
  let shareQuery = "";
  if (isShare && User.PublisherId()) {
    let publisherId = User.PublisherId();
    let parentPublisherId = User.ParentPublisherId();
    if (!publisherId || publisherId.length !== 10) {
      publisherId = GetDefaultAdsenseId(1);
    }
    if (!parentPublisherId || parentPublisherId.length !== 10) {
      parentPublisherId = GetDefaultAdsenseId(2);
    }
    shareQuery = `${
      val.includes("?") ? "&" : "?"
    }shareid=${publisherId}_${parentPublisherId}`;
  }
  return `/${productCode.toLowerCase()}/${languageCode}/${val}${shareQuery}`;
};
export const Clone = (obj, defaultError = null) => {
  try {
    return JSON.parse(JSON.stringify(obj));
  } catch (e) {
    console.log("clone-error", e.message);
    return defaultError;
  }
};
export const HasProperty = (events, key) => {
  return !!Object.prototype.hasOwnProperty.call(events, key);
};
export const GetPage = (pathName, languageCode, productCode) => {
  let { currentPath } = ExtractPath(
    CleanUrl(pathName),
    languageCode,
    productCode,
  );
  currentPath = currentPath.filter((item) => item.length !== 2);
  const categoryCode = currentPath.find((path) =>
    [
      "services",
      "categories",
      "viewitem",
      "viewbusinessprofile",
      "confirmpayment",
      "dailytimerecord",
      "findcontent",
      "viewcontent",
      "viewmycv",
      "viewjobpost",
      "jobpostsskills",
      "lotterygamelist",
    ].includes(path),
  );
  return categoryCode ?? currentPath[currentPath.length - 1] ?? "home";
};
export const Waiter = async (seconds = 2000) => {
  if (seconds) {
    await new Promise((resolve) => setTimeout(resolve, seconds));
  }
};
export const GetParameterByName = (name, isExact = false) => {
  let url = GetState(CFW_CURRENT_URL);
  url = isExact ? url : url.toLowerCase();
  name = isExact
    ? name.replace(/[\[\]]/g, "\\$&")
    : name.replace(/[\[\]]/g, "\\$&").toLowerCase();
  const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return "";
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
};
export const GetTranslation = () => {
  const translationData = GetState(
    globalVariables[CFW_CURRENT_TRANSLATION],
    GetState(Response_TranslationData),
  );
  if (!translationData && typeof window !== "undefined") {
    return (
      window.initScripts[globalVariables[CFW_CURRENT_TRANSLATION]] ??
      window.initScripts[Response_TranslationData]
    );
  }
  return translationData;
};
export const OnlyAlphaNumeric = (val, strict = false) => {
  if (strict) {
    return val.replace(/[^a-z A-Z 0-9]+/gi, "");
  }
  return val.replace(/[^a-z A-Z 0-9 \. ,]+/gi, "");
};
export const GetProductAndLanguage = (pathname = "") => {
  const finalPath = pathname.replace("https://urtechcity.com", "");
  return {
    languageCode: CurrentLanguageCode(finalPath),
    ...GetProductCode(finalPath),
  };
};
const CurrentLanguageCode = (pathname) => {
  try {
    const langParam = pathname.split("/").find((a) => a.length === 2);
    let lang = langParam;
    lang = (lang ?? "en").toLowerCase();
    let getLanguageCode = LanguagesData;
    if (getLanguageCode) {
      getLanguageCode = getLanguageCode.find(
        (item) => item.LanguageCode === lang,
      );
      lang = getLanguageCode?.LanguageCode ?? "en";
    }
    return lang;
  } catch (e) {
    console.log("error", e.message);
  }
};
const GetProductCode = (location) => {
  try {
    let urlParam = location.includes("?") ? location.split("?")[0] : location;
    urlParam = urlParam.split(UI_URL).filter((item) => !!item)[0] || "";
    urlParam = urlParam
      .toLowerCase()
      .split("/")
      .filter((item) => !!item && item !== "#");
    if (location.toLowerCase() === UI_URL.toLowerCase()) {
      console.log(urlParam);
    }
    if (urlParam.includes("urtechcity")) {
      return {
        productCode: "URTECHCITY",
        title: "UrTechCity",
      };
    } else if (urlParam.includes("urtechpogo")) {
      return {
        productCode: "URTECHPOGO",
        title: "UrTechPOGO",
      };
    } else if (urlParam.includes("urtechpos")) {
      return {
        productCode: "URTECHPOS",
        title: "UrTechPOS",
      };
    } else if (urlParam.includes("upublishme")) {
      return {
        productCode: "UPUBLISHME",
        title: "UPublishMe",
      };
    } else if (urlParam.includes("urtechshop")) {
      return {
        productCode: "URTECHSHOP",
        title: "UrTechShop",
      };
    } else {
      return {
        productCode: "JOBPORTAL",
        title: "JobPortal",
      };
    }
  } catch (e) {
    console.log("error", "GetProductCode", e.message);
  }
};
